<template>
    <div class="gray-back" style="padding:.2rem 0 8rem 0">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>
                <van-field
                        v-model="formData.saiqu_name"
                        label="赛区"
                        input-align="right"
                        readonly
                />
                <van-field
                        v-model="formData.danwei"
                        label="单位"
                        input-align="right"
                        readonly
                />
                <van-field
                        v-model="formData.mingcheng"
                        :rules="[{ required: true, message: '队伍名称不能为空' }]"
                        label="队伍名称"
                        :border="false"
                        input-align="right"
                        error-message-align="right"
                        clearable
                        placeholder="请输入队伍名称"
                />
                <div class="operate-desc-left" v-show="formData.mingcheng">您的队伍全称是 {{formData.danwei}} {{formData.mingcheng}} {{formData.mingcheng_end}}</div>


                <van-cell title="队伍照片" :value="formData.heying.length+'/1'">
                    <!--<template slot="icon" >-->
                        <!--<van-icon class="question-icon" name="question-o" @click="onQuestion('heying')"/>-->
                    <!--</template>-->
                </van-cell>

                <div class="row">
                    <PicUploader :fileList="formData.heying" :limit="1"
                                 :name="'heying'"></PicUploader>
                </div>
                <div class="operate-desc-left">上传一张队伍照片</div>

                <van-field
                        v-model="formData.ldname"
                        label="领队姓名"
                        :rules="[{ required: true, message: '领队姓名不能为空' }]"
                        error-message-align="right"
                        input-align="right"
                        clearable
                        placeholder="请输入领队姓名"
                />

                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        @click="showNumTypePicker=true"
                        label="证件类型"
                        v-model="formData.numTypeName"
                />
                <van-popup v-model="showNumTypePicker" position="bottom">
                    <van-picker :columns="numTypeColumns"
                                show-toolbar
                                :default-index="formData.ldcardtype-1"
                                @cancel="showNumTypePicker = false"
                                @confirm="onNumTypeConfirm"
                    />
                </van-popup>

                <van-field
                        v-model="formData.ldnum"
                        label="证件号码"
                        :rules="[{ required: true, message: '证件号码不能为空' }]"
                        error-message-align="right"
                        input-align="right"
                        clearable
                        placeholder="请输入证件号码"
                />

                <van-field name="radio" label="领队性别"
                           input-align="right">
                    <template #input>
                        <van-radio-group v-model="formData.ldsex" direction="horizontal">
                            <van-radio checked-color="#ffb01b" :name="1">男</van-radio>
                            <van-radio checked-color="#ffb01b" :name="2">女</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>


                <van-field
                        v-model="formData.phone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="领队手机"
                        input-align="right"
                        clearable
                        placeholder="请输入手机"
                />

                <van-field
                        v-model="formData.lxname"
                        label="联系人"
                        :rules="[{ required: true, message: '联系人不能为空' }]"
                        error-message-align="right"
                        input-align="right"
                        clearable
                        placeholder="请输入联系人姓名"
                />


                <van-field
                        v-model="formData.lxphone"
                        :rules="[{ validator: validator.phone,message:'请输入正确的手机号'}]"
                        error-message-align="right"
                        label="联系人手机"
                        input-align="right"
                        clearable
                        placeholder="请输入手机"
                />

            </van-cell-group>


            <van-divider>教练裁判信息</van-divider>

            <van-cell-group>

                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        label="随队裁判"
                        placeholder="请选择裁判"
                        @click="showCaipanPicker = true"
                />


                <div class="memberResultWrap" v-show="formData.caipan.length>0">
                    <div class="memberLi" v-for="(caipan ,index) in formData.caipan">
                        裁判员
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                closeable
                                type="primary"
                                @close="formData.caipan.splice(index,1)"
                        > {{caipan.name}} {{caipan.num}}
                        </van-tag>
                    </div>
                </div>

                <van-field
                        readonly
                        clickable
                        right-icon="arrow"
                        input-align="right"
                        label="教练员"
                        placeholder="请选择教练员"
                        @click="showJiaolianPicker = true"
                />

                <div class="memberResultWrap" v-show="formData.jiaolian.length>0">
                    <div class="memberLi" v-for="(jiaolian ,index) in formData.jiaolian">
                        教练员{{index+1}}
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                closeable
                                type="primary"
                                @close="formData.jiaolian.splice(index,1)"
                        > {{jiaolian.name}} {{jiaolian.num}}
                        </van-tag>
                    </div>
                </div>



            </van-cell-group>


            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">下一步</van-button>
            </div>
        </van-form>


        <CaipanPicker
                :show="showCaipanPicker"
                :limit="1"
                @onChange="onCaipanChange"
                @onClose="showCaipanPicker=false"
                :defaultValue="formData.caipan"
                @onConfirm="onCaipanConfirm"
        ></CaipanPicker>


        <JiaolianPicker
                :show="showJiaolianPicker"
                :limit="5"
                @onChange="onJiaolianChange"
                @onClose="showJiaolianPicker=false"
                :defaultValue="formData.jiaolian"
                @onConfirm="onJiaolianConfirm"
        ></JiaolianPicker>

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep1',
        components: {
            [Field.name]: Field,
            PicUploader,
            CaipanPicker,
            JiaolianPicker,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                saiqu_id: this.$route.query.saiqu_id,
                showCaipanPicker:false,
                showJiaolianPicker:false,
                showNumTypePicker:false,
                numTypeColumns: ['身份证', '护照'],
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id:0,
                    saiqu_name:'',
                    numTypeName:'身份证',
                    danwei:'',
                    ldcardtype:1,
                    mingcheng_end:'',
                    mingcheng:'',
                    ldsex:1,
                    heying:[{name:"选择商户.png",
                        save_name:"h5/2020-05-11/1589187988243621.png",
                        uid:"vc-upload-1589187988243621",
                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
                    }],
                    caipan:[],
                    jiaolian:[],
                },
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
          document.title="赛事申请"
            that.formData.id = this.$route.query.id;
            this.fetch();
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            fetch(){
                let that = this;
                that.$api.get('/api/sai/step1Detail', {
                    saiqu_id : that.saiqu_id,
                    id : that.formData.id,
                }, (res) => {
                    that.formData = Object.assign(that.formData, res.data)
                })
            },
            onQuestion(){
                console.log('onQuestion')
            },
            onCaipanConfirm(values){
                console.log('onCaipanConfirm',values)
                this.showCaipanPicker = false;
                this.formData.caipan = [...values];
            },
            onCaipanChange(values){
                console.log('onCaipanChange',values)
                this.formData.caipan = [...values];
            },
            onCaipanConfirm(values){
                console.log('onCaipanConfirm',values)
                this.showCaipanPicker = false;
                this.formData.caipan = [...values];
            },
            onCaipanChange(values){
                console.log('onCaipanChange',values)
                this.formData.caipan = [...values];
            },
            onJiaolianConfirm(values){
                console.log('onJiaolianConfirm',values)
                this.showJiaolianPicker = false;
                this.formData.jiaolian = [...values];
            },
            onJiaolianChange(values){
                console.log('onJiaolianChange',values)
                this.formData.jiaolian = [...values];
            },
            onNumTypeConfirm(value, index){
                this.formData.numTypeName = value;
                this.formData.ldcardtype = index+1;
                this.showNumTypePicker = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                    if (that.formData.heying.length == 0) {
                        Toast('请上传队伍照片');
                        return
                    }
                    if (this.formData.jiaolian.length==0) {
                        Toast('请至少选择一位教练');
                        return
                    }
                }
                that.saveLoading = true;
                that.$api.post('/api/sai/baoming', that.formData, (res) => {
                    that.saveLoading = false;
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyFormStep1.vue?8071d1dc